<template>
  <el-dialog
    :visible="isVisible"
    width="90%"
    top="5vh"
    @close="onClose"
    :close-on-click-modal="false"
  >
    <StartupProfile
      v-loadcover="fetchInProgress"
      :can-user-see-private-data="true"
    />
  </el-dialog>
</template>

<script>
import StartupProfile from '@/modules/startup-profile/StartupProfile.vue'
import { mapState } from 'vuex'

export default {
  components: { StartupProfile },
  props: ['startupId'],
  data() {
    return {
      prevRoute: null,
      isVisible: false,
    }
  },
  computed: {
    ...mapState({
      fetchInProgress: (state) =>
        state.startupProfile.fetchInProgress || state.user.fetchInProgress,
    }),
  },
  created() {
    this.isVisible = true
    window.vm = this
    this.$store.dispatch('startupProfile/clean')
    this.$store.dispatch('startupProfile/fetch', { id: this.startupId })
    this.$store.commit(
      'startupProfileInvestorClassifies/setStartupId',
      this.startupId,
    )
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  methods: {
    onClose() {
      if (this.prevRoute.name === 'organizationFunnel') {
        this.$router.back()
      } else {
        this.$router.push({ name: 'organizationFunnel' })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  margin-top: 0;
}
</style>
